<template>
  <div>

    <nav class="navbar navbar-default navbar-fixed-top" role="navigation" id="shrink">

        <div class="container contain-top" id="upper-nav-shrink">

            <div class="contain-top-lower">

                <!-- Brand and toggle get grouped for better mobile display -->

                <div class="navbar-header">


                  <b-navbar-toggle id="openMenu" @click="showCloseMenu()" target="navbar-toggle-collapse-mob" class="nav float-right d-lg-none mob-navbar" style="border: 0; outline: none; display: block;">
                    <i class="fa fa-bars" aria-hidden="true"></i>
                  </b-navbar-toggle>
                  <b-navbar-toggle id="closeMenu"  @click="showOpenMenu()" target="navbar-toggle-collapse-mob" class="nav float-right d-lg-none mob-navbar" style="border: 0; outline: none; display: none;">
                    <span class="hamburger-box">
                    <span class="hamburger-inner">

                    </span>
                    </span>
                  </b-navbar-toggle>
    
                    <a class="navbar-brand logo-main" :href="mmSiteUrl">
                        <img :src="mmSiteUrl + 'hubfs/Mentor_Mentee_May2025/Images/MM-logo.png'" 
                            alt="Mentor Mentee">
                    </a>

                </div>

                  <b-collapse id="navbar-toggle-collapse-mob" class="d-lg-none kl-navbar__menu ">
                    <b-navbar-nav class=" nav navbar-nav navbar-right" style="width: 95%; margin: 0;">
                    <b-nav-item-dropdown text="Product" right>
                      <b-nav-item :href="mmSiteUrl + 'product'" class="kl-navbar__item kl-navbar__parent">
                        <div class="text-center btn-mobile-cta">
                          Product
                        </div>
                      </b-nav-item>
                   
                      <b-nav-item :href="mmSiteUrl + 'faq'" class="btn btn-danger btn-login">
                        <div class="text-center btn-mobile-cta">
                          FAQS
                        </div>
                      </b-nav-item>
                    </b-nav-item-dropdown>
                    <b-nav-item-dropdown text="About Us" right>
                      <b-nav-item :href="mmSiteUrl + 'about'" class="btn btn-danger btn-login">
                        <div class="text-center btn-mobile-cta">
                          Meet the Team
                        </div>
                      </b-nav-item>
                      <b-nav-item :href="mmSiteUrl + 'contact-us'" class="btn btn-danger btn-login">
                        <div class="text-center btn-mobile-cta">
                          Contact Us
                        </div>
                      </b-nav-item>
                    </b-nav-item-dropdown>
                      <b-nav-item :href="mmSiteUrl + 'resource-center'" class="btn btn-danger btn-login">
                        <div class="btn-mobile-cta1" style="padding-top: 14px !important;">
                          Resource Center
                        </div>
                      </b-nav-item>
                      <b-nav-item :href="mentoringUrl + 'mmlogin'" class="btn btn-danger btn-login">
                        <div class="btn-mobile-cta1">
                          Log In
                        </div>
                      </b-nav-item>
                      <b-nav-item :href="mmSiteUrl + 'contact-us'" class="text-center contact-btn" >
                        <div class="contactus-btn">
                          Contact Us
                        </div>
                      </b-nav-item>
                    </b-navbar-nav>
                  </b-collapse>


                <!-- mobile nav ->

                <!-- Collect the nav links, forms, and other content for toggling -->

                <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">




                    <!-- desktop nav -->

                    <div id="dnav"> 

                    <ul class="nav navbar-nav navbar-right d-none d-lg-block">

                    <li id="menu-item-764" class="menu-item menu-item-type-post_type menu-item-object-page mm-login contactus-btn">
                        <a :href="mmSiteUrl + 'contact-us'"  style="color: #FFF !important;" >Contact Us</a>
                    </li>

                    </ul>
                                            


                    <ul id="menu-main-menu" class="nav navbar-nav navbar-right d-none d-lg-block">

                        <li id="menu-item-764"
                            class="menu-item menu-item-type-post_type menu-item-object-page menu-item-764 ">
                            <a :href=" mentoringUrl + 'mmlogin'" class="" >Log
                                In</a>
                        </li>

                    </ul>
                                            
                    <ul id="menu-main-menu" class="nav navbar-nav navbar-right d-none d-lg-block">

                        <li id="menu-item-764"
                            class="menu-item menu-item-type-post_type menu-item-object-page menu-item-764 ">
                            <a :href="mmSiteUrl + 'technical-mentoring-news'" class="" >Resource Center</a>
                        </li>

                    </ul>
                            

                   <ul id="menu-main-menu" class="nav navbar-nav navbar-right d-none d-lg-block" >

                      <li class="dropdown-3">
                      
                         <div class="dropdown">About Us

                              <div class="dropdown-content">
                                <div class="kl-navbar-submenu" >
                                <a :href="mmSiteUrl + 'about'" >
                                    Meet the Team
                                </a>
                            
                                <a :href="mmSiteUrl + 'contact-us'" >
                                    Contact Us
                                </a>
                                </div>
                              </div>
                           </div>
                     
                        </li>

                    </ul>                         

                                                               
                    
                    <ul id="menu-main-menu" class="nav navbar-nav navbar-right d-none d-lg-block" >

                      <li class="dropdown-3">
                      
                         <div class="dropdown">Product

                              <div class="dropdown-content">
                                <div class="kl-navbar-submenu" >
                                <a :href="mmSiteUrl + 'product'" >
                                    Product
                                </a>
                            
                                <a :href="mmSiteUrl + 'faq'" >
                                    FAQs
                                </a>
                                </div>
                              </div>
                           </div>
                     
                        </li>

                    </ul>
                                            
               

                  <b-collapse id="navbar-toggle-collapse-about" class="">
                    <b-navbar-nav class="nav dropdown-menu" style="">
                      <b-nav-item :href="mmSiteUrl" class="">
                        <div class="text-center ">
                          Home
                        </div>
                      </b-nav-item>
                      <b-nav-item :href="mmSiteUrl + 'about'" class="btn btn-danger btn-login">
                        <div class="text-center">
                          About Us
                        </div>
                      </b-nav-item>
                    </b-navbar-nav>
                   </b-collapse>             
                    

                    </div>

                    <!-- desktop nav -->

                    <!-- /.navbar-collapse -->

                </div>

                <!-- /.container -->

            </div>
        </div>








    </nav>


    </div>
</template> 
<style scoped>
.logo-main img {
    width: 125px;
    height: auto;
    margin-top: 4px;
}
.navbar > .container {
   display: block !important; 
}
.mm-login {
    margin-top: -6px;
}
.navbar-nav>li {
    float: left;
}
#menu-main-menu li a {
    margin-top: 5px;
}
.navbar a {
    color: #002F42 !important;
    border-right: none;
    text-decoration: none;
    font-size: 16px;
}
#dropdown-3 .dropdown-menu a:hover {
  background-color: #FFF;
  color: #00ACEE !important;
}
.navbar-collapse.collapse {
    display: block!important;
}
.navbar-right {
    float: right!important;
    margin-right: 20px;
}
#menu-main-menu {
    margin-right: 30px;
}
.navbar-header {
    float: left;
}
.navbar-brand {
   padding: 0px !important;
   float: left;
   height: auto;
   font-size: 18px;
    line-height: 20px;
} 
#dnav {
    margin-top: 0px !important;
}
.container {
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
}
.navbar a {
    display: block;
}
.nav-item img {
    height: 36px;
    width: auto;
}
.nav-item a{
    text-decoration: none;
    color: #FFF;    
}
@media (min-width: 1200px){
    .container {
        width: 1170px !important;
    }
    #desktop_nav { display: block; }
    #mobile_nav { display: none; }
}
/* Mobile */
@media (min-width:320px) and (max-width: 767px ) {
    .logo-main { margin-left: 10px; }
    .container {
        padding-right: 0px !important;
        padding-left: 0px !important;
    }
    .navbar a { margin-left: 0px !important; margin-top: -10px !important; }
    .navbar-brand { padding: 10px; }
}
.navbar-default {
    background-color: #FFF;
    border-color: #FFF;
}
.contain-top {
    margin-top: 5px;
}
@media (min-width: 768px) {
.navbar-header {
    float: left;
}
.navbar-right {
    float: right!important;
    margin-right: -15px;
}
}
.nav>li {
    position: relative;
    display: block;
    width: auto;
    margin: 0px 15px;
}
#dnav .navbar-nav i {
  color: #002F42 !important;
  font-weight: normal !important;
  padding-left: 4px;
  font-size: 13px;
}
.navbar-fixed-top {
    height: 72px !important;
    position: fixed;
    right: 0;
    left: 0;
    z-index: 1030;
    box-shadow: 0px 5px 10px rgba(154, 161, 177, 0.1);
}
@media (max-width: 991px) {
  .navbar-collapse.collapse.in {
      display: block!important;
      max-height: 100% !important;
  }
  .navbar-fixed-top {
    box-shadow: none;
  }
  #navbar-toggle-collapse-mob {
    position: absolute;
    z-index: 1030;
    width: 100%;
    top: 72px;
    text-align: center;
    background-color: #FFF;
  }
  .navbar-header {
    padding-left: 15px;
    padding-right: 10px;
    width: 100%;
  }
  .mob-navbar i {
      display: block;
      height: 4px;
      width: 24px;
      margin-top: 3px;
      color: #FFF;
      font-size: 24px;
  }
  .mob-navbar[aria-expanded="true"] i {
      padding: 0;
      color: #002F42 !important;
  }
  .mob-navbar[aria-expanded="false"] i {
      padding: 0;
      color: #002f42 !important;
  }
  #navbar-toggle-collapse-mob li, #navbar-toggle-collapse-mob li a {
    padding: 0 !important;
    margin: 0 !important;
  }
  #navbar-toggle-collapse-mob li ul li a {
    padding: 8px 0 8px 7px !important;
  }
  #navbar-toggle-collapse-mob .btn-danger {
    background: #ffffff !important;
    border: 0;
  }
  body nav .btn-mobile-cta:hover {
    text-decoration: none;
  }
  body nav .btn-mobile-cta1 {
      color: #002F42 !important;
      padding-top: 20px !important;
      padding-bottom: 0px !important;
      margin: 0;
  }
  body nav .btn-mobile-cta {
      color: #002F42 !important;
      padding-top: 10px !important;
      padding-bottom: 0px !important;
      margin: 0;
  }
}
/* New CSS Changes */
.dropdown {
  position: relative;
  display: inline-block;
  font-size: 16px;
}

.dropdown-content {
  display: none;
  position: absolute;
  min-width: 160px;
  z-index: 1;  
  margin-top: 13px;
}

.dropdown-content a {  
  padding: 10px 14px;
  text-decoration: none;
  display: block;  
}

.dropdown-content a:hover {
  background-color: #FFF; 
  color: #00ACEE !important;    
}

.dropdown:hover .dropdown-content {
  display: block;
}
.contactus-btn {  
  background-color: rgba(0, 172, 238, 1.0);
  border: 0px solid rgba(0, 172, 238, 1);
  border-radius: 18px;
  color: rgba(255, 255, 255, 1);
  padding: 10px 50px;  
  font-size: 0.75rem;
  font-weight: bold;
  display: inline-block;
  width: auto;
  height: auto;
  margin: 0;
  cursor: pointer;
  line-height: 1.1;
  letter-spacing: 0.03em;
  white-space: normal;
  word-break: break-word;
  text-align: center;
  text-decoration: none;
  position: relative;
  transition: all 0.15s linear;
}  
.nav>li:hover {
    color: #00ACEE !important;      
    cursor: pointer;
}
.nav>li .dropdown:hover {
    color: #00ACEE !important;      
    border-bottom: 2px solid #00ACEE;
    padding-bottom: 10px;   
}
#menu-main-menu li a:hover {
    color: #00ACEE !important;     
    border-bottom: 2px solid #00ACEE;
    padding-bottom: 10px;   
}
#menu-main-menu li .dropdown-content a:hover {
    color: #00ACEE !important;     
    border-bottom: 0px solid #00ACEE;
    padding-bottom: 10px;
}


#navbar-toggle-collapse-mob li a {
  text-align: left;
}
.contact-btn a {
  display: block !important;
  text-align: center !important;
}
.contact-btn a .contactus-btn {
  margin-top: 15px !important;
}
@media screen and (max-width: 920px) {
    #navbar-toggle-collapse-mob {
        background-color: rgba(255, 255, 255, 1.0);
        position: fixed;
        width: 100%;
        left: 0;
        bottom: 0;
        padding: 45px 10%;
        flex-direction: column;
        justify-content: space-between;
        overflow-y: auto;
        transform: translateY(8px);
        transition: transform .25s ease-in-out, opacity .25s ease-in-out;
        display: flex;
    }
}
.kl-navbar-submenu {
  background-color: #FFF;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  padding: 0;
  margin: 20px 0 0;
  width: 160px;
  position: relative;
  box-sizing: border-box;
}
.hamburger-box {
  width: 24px;
  height: 19px;
  display: inline-block;
  position: relative;
}
.hamburger-inner {
  transform: rotate(45deg);
  transition-delay: 0.12s;
  transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  width: 24px;
  height: 3px;
  background-color: #002F42;
  position: absolute;
  transition-property: transform;
  display: block;
  top: 50%;
  margin-top: 2.5px;

}
.hamburger-inner::before {
  content: "";
  display: block;
  top: 0;
  opacity: 0;
  transition: top 0.075s ease, opacity 0.075s 0.12s ease;
  width: 24px;
  height: 3px;
  background-color: #002F42;
  position: absolute;
}
.hamburger-inner::after {
  content: "";
  display: block;
  bottom: 0;
  transform: rotate(-90deg);
  transition: bottom 0.075s ease, transform 0.075s 0.12s cubic-bezier(0.215, 0.61, 0.355, 1);
  width: 24px;
  height: 3px;
  background-color: #002F42;
  position: absolute;
}
</style>
<script>
export default {
    props: ['mmSiteUrl'],
    data() {
        return {
          mentoringUrl: process.env.VUE_SITE_URL,
        }
    },
    methods: {
        onOver() {
          this.$refs.dropdown.visible = true;
        },
        onLeave() {
          this.$refs.dropdown.visible = false;
        },
        showCloseMenu() {
          document.getElementById("openMenu").setAttribute("style","display: none;");
          document.getElementById("closeMenu").setAttribute("style","display: block;");
        },
        showOpenMenu() {
          document.getElementById("openMenu").setAttribute("style","display: block;");
          document.getElementById("closeMenu").setAttribute("style","display: none;");
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/mm_header.vue